import { CaseStatusFilterOptions } from '../../enums/filters-and-searchs/case.status.options';

export const CaseStatusFilterOptionsDetail = new Map<number, string>([
    [CaseStatusFilterOptions.None, 'None'],
    [CaseStatusFilterOptions.Deleted, 'Deleted Case Status']
]);
